export default __webpack_public_path__ + "static/media/close-icon.bbe41ca5.svg";